/*
 * People API (AnalyticsService /v1/people/*, redesign 2026-10-09). Ids above 2^53 arrive as strings
 * (json-bigint storeAsString via the audiences call helper): never Number() an id.
 * Every read returns null on failure so screens fall back to the older endpoints.
 */
import { call } from "../audiences/api";
import endpoints from "../../endpoints";
const BASE = (endpoints.audience && endpoints.audience.root || "") + "/people"; // https://api.../v1/people

// Reads fall back (null) on ANY failure, not only "not deployed": a slow first load on a very large workspace can
// time out at the gateway, and the screens then show today's data instead of an error page.
export const peopleGet = (path, query) => call(`${BASE}${path}`, {
  query
}).catch(e => {
  if (typeof console !== "undefined") console.warn("people api fallback", path, e && e.status);
  return null;
});
export const peopleSend = (method, path, body) => call(`${BASE}${path}`, {
  method,
  body
});
export const getContacts = q => peopleGet("/contacts", q); // {items, count, counts}
export const getActOn = (top = 6) => peopleGet("/act-on", {
  top
}); // {items}
export const getContactCustomers = id => peopleGet(`/contacts/${encodeURIComponent(String(id))}/customers`); // {items:[{id, customerNumber, name, stage, type, isPrimary}]}
export const getContactTimeline = (id, q) => peopleGet(`/contacts/${encodeURIComponent(String(id))}/timeline`, q); // {stats, items}
export const getCustomers = q => peopleGet("/customers", q); // {items, count, counts, summary}
export const getCustomer = id => peopleGet(`/customers/${encodeURIComponent(String(id))}`); // {account, stats, salesByMonth, orders, people, lapse}
export const getCustomerNotes = id => peopleGet(`/customers/${encodeURIComponent(String(id))}/notes`); // {items}
export const addCustomerNote = (id, text) => peopleSend("POST", `/customers/${encodeURIComponent(String(id))}/notes`, {
  text
});
export const getLifecycleOverview = q => peopleGet("/lifecycle", q); // {stages, moves, ready, stuck}